import React from 'react';

const StatsCard = ({ label, value, Icon, color }) => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-medium text-slate-500">{label}</h3>
        {Icon && <Icon className={color} size={24} />}
      </div>
      <p className="text-3xl font-bold text-slate-900">{value}</p>
    </div>
  );
};

export default StatsCard;
